// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import type { FormProps } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { containsValidLicenses } from 'util/licenseUtils';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import { ADD_LICENSE_PANEL_ID } from 'util/constants';
import localizedStrings from 'util/localizedStrings';
import { addLicenses } from 'state/commands/licenseCommands';
import {
  hideDialogPanel,
  showDialogPanel,
} from 'state/commands/dialogPanelCommands';

type Props = {
  activePanelId: ?string,
  addLicenses: typeof addLicenses,
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
  licenseText: string,
  showDialogPanel: typeof showDialogPanel,
} & FormProps;

class AddLicenseDialog extends Component<Props> {
  handleClose: Function;
  handleKeyDown: Function;
  isOkEnabled: Function;
  submit: Function;

  constructor() {
    super();

    this.handleClose = this.handleClose.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.submit = this.submit.bind(this);
  }

  isOkEnabled() {
    return this.props.valid && !this.props.pristine;
  }

  handleKeyDown(e: SyntheticKeyboardEvent<>) {
    return e.keyCode === 13 && !e.ctrlKey;
  }

  handleChange(event, newValue, previousValue, name) {
    if (!/^[a-zA-Z0-9-\s]*$/.test(newValue)) {
      event.preventDefault();
    }
  }

  handleClose() {
    this.props.reset();
  }

  submit(values) {
    const { addLicenses, hideDialogPanel, intl, licenseText } = this.props;
    hideDialogPanel();
    addLicenses(licenseText, intl);
    this.handleClose(); // resets the form, so call after we use the licenseText value.
  }

  render() {
    const {
      activePanelId,
      intl: { formatMessage },
      handleSubmit,
      hideDialogPanel,
    } = this.props;

    return (
      <div>
        <DialogPanel
          activePanelId={activePanelId}
          closeAfterSave={false}
          contentStyle={{ width: '500px', height: null }}
          customButtonText={formatMessage(localizedStrings.LIC_ADD_SN_SHORT)}
          dialogFocusId="licenses"
          handleKeyDown={this.handleKeyDown}
          hideDialogPanel={hideDialogPanel}
          isOkEnabled={this.isOkEnabled}
          onClose={this.handleClose}
          onSave={handleSubmit(this.submit)}
          panelId={ADD_LICENSE_PANEL_ID}
          panelTitle={formatMessage(localizedStrings.LIC_ADD_SN_SHORT)}
          showCancel
        >
          <div className="container" style={{ padding: '30px' }}>
            <div className="field">
              <label className="label">
                <FormattedMessage {...localizedStrings.LIC_ADD_MESSAGE} />
              </label>
              <div className="control">
                <Field
                  className="textarea"
                  component="textarea"
                  id="licenses"
                  name="licenses"
                  onChange={this.handleChange}
                  rows="10"
                  type="text"
                  style={{ resize: 'none' }}
                />
              </div>
            </div>
          </div>
        </DialogPanel>
      </div>
    );
  }
}

function validate(data) {
  const errors = {};

  if (!containsValidLicenses(data.licenses)) {
    errors.licenses = 'Required';
  }

  return errors;
}

const form = reduxForm({
  form: ADD_LICENSE_PANEL_ID,
  validate,
})(injectIntl(AddLicenseDialog));

const selector = formValueSelector(ADD_LICENSE_PANEL_ID);
export default connect(state => ({
  licenseText: selector(state, 'licenses'),
}))(form);



// WEBPACK FOOTER //
// ./src/view/Pages/LicensesPage/AddLicenseDialog.js